
export interface AdhocHoldOfCntrSearchCriteria {
    consortiumCode?: string | null,
	vesselCode?: string | null,
	voyageCode?: string | null,
	cntrNoList?: string[] | null,
	billOfLading?: string | null,
	shippingBill?: string | null,


    [key: string]: string | number | null | undefined | Object
}

export const EMPTY_ADHOC_HOLD_OF_CNTR_SEARCH_CRITERIA: AdhocHoldOfCntrSearchCriteria = {
    consortiumCode: '',
    vesselCode: '',
    voyageCode: '',
    cntrNoList: [],
    billOfLading: null,
    shippingBill: null
}